import {useGetData} from '../../src/apiservice/apiCall'


export function useExport(){
	return useGetData('/api/WebApi/GetExport')
}
